import { withPanZoom } from './with-timebar-pan-zoom';
import { withTimeScale } from './with-timebar-scales';
import { withTimebarMetadata } from './with-timebar-data';
import { withTimebarListContainer } from './with-timebar-list';

import { Timebar as TimebarComponent } from './components/timebar';
import { TimebarList as TimebarListComponent } from './components/timebar-list';

export const Timebars = withTimebarListContainer(TimebarListComponent);
export const Timebar = withTimeScale(withPanZoom(withTimebarMetadata(TimebarComponent)));
